import {useContext} from 'react';
import {useHistory} from 'react-router-dom';
import 'aframe';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {FaHome as HomeIcon} from 'react-icons/fa';
import {FaShoppingCart as CartIcon} from 'react-icons/fa';
import {BsChatDots as ChatIcon} from 'react-icons/bs';
import {BiCalendar as CalendarIcon} from 'react-icons/bi'
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import {MenuButtonCmp as MenuButton} from './MenuCmp';
import {AppConfigState} from '../providers/AppConfigProvider';
import {openCart} from '../services/Shopify';
import InteractiveTutorialCmp from './InteractiveTutorialCmp';

const SceneUI = styled.div`
  position: fixed;  
  right: 10px;
  bottom: 10px;
  display: flex;
`;

const UIControlsCmp = ({homeUrl, calendarId, cart}) => {
  //ui
  const history = useHistory();
  const appConfig = useContext(AppConfigState);

  const handleHome = () => {
    appConfig.dispatch({type: 'closeChat'});
    history.push(homeUrl);
  };

  const handleChat = () => {
    appConfig.dispatch({type: 'toggleChat'});
  }

  const handleToggleCart = (event) => {
    event.stopPropagation();
    openCart();
  };

  return (
    <>
      <SceneUI id="ui-controls">
          <ButtonGroup>
            <Button variant="light" onClick={handleHome}>
              <HomeIcon />
            </Button>
            <Button variant="light" onClick={handleChat}>
              <ChatIcon />
            </Button>
            {calendarId && (
              <Button as="a" variant="light"  href={`https://calendly.com/${calendarId}`} target="_blank">
                <CalendarIcon />
              </Button>
            )}
            {cart && (
              <Button variant="light" onClick={handleToggleCart}>
                <CartIcon />
              </Button>
            )}
            <InteractiveTutorialCmp />
            <MenuButton />
          </ButtonGroup>
      </SceneUI>
      <div id="tutorial-instructions" 
        style={{
          'bottom': '100px',
          'right': '0px',
        }}
        >
          <div id="tutorial-content"></div>
        </div>
    </>
  );
}

UIControlsCmp.propTypes = {
  homeUrl: PropTypes.string.isRequired,
  calendarId: PropTypes.string,
  cart: PropTypes.bool,
};

UIControlsCmp.defaultProps = {
  calendar: false,
  cart: false,
};

export default UIControlsCmp;
